/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sweet_Low_Scallop_FetchInputs */

const fr_sweet_low_scallop_fetch = /** @type {(inputs: Sweet_Low_Scallop_FetchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discussion`)
};

/**

* @param {Sweet_Low_Scallop_FetchInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sweet_low_scallop_fetch = /** @type {((inputs?: Sweet_Low_Scallop_FetchInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sweet_Low_Scallop_FetchInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sweet_low_scallop_fetch(inputs)
});